export class Header {

    static init() {
        Header.mobileMenu();
        Header.searchForm();
        //
    }

    static mobileMenu() {
        // Open mobile menu
        document.body.addEventListener('click', function (e) {
            const target = e.target.closest('.js-mobile-menu');
            if (!target) return;
            
            e.preventDefault();
            const header = document.querySelector('.js-header');
            const mobileMenu = document.querySelector('.header__mobile-menu');
            const hamburger = target;
            
            if (header) header.classList.add('is-opened');
            if (mobileMenu) mobileMenu.classList.add('is-opened');
            hamburger.setAttribute('aria-expanded', 'true');
            document.body.style.overflow = 'hidden';
        });

        // Close mobile menu
        document.body.addEventListener('click', function (e) {
            const target = e.target.closest('.js-mobile-menu-close');
            if (!target) return;
            
            e.preventDefault();
            const header = document.querySelector('.js-header');
            const mobileMenu = document.querySelector('.header__mobile-menu');
            const hamburger = document.querySelector('.js-mobile-menu');
            
            if (header) header.classList.remove('is-opened');
            if (mobileMenu) mobileMenu.classList.remove('is-opened');
            if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
            document.body.style.overflow = '';
        });

        // Close menu when clicking outside
        document.body.addEventListener('click', function (e) {
            const mobileMenu = e.target.closest('.header__mobile-menu');
            if (!mobileMenu) return;
            
            if (e.target.classList.contains('header__mobile-menu')) {
                const header = document.querySelector('.js-header');
                const hamburger = document.querySelector('.js-mobile-menu');
                
                if (header) header.classList.remove('is-opened');
                mobileMenu.classList.remove('is-opened');
                if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
                document.body.style.overflow = '';
            }
        });

        // Children item
        document.body.addEventListener('click', function (e) {
            const target = e.target.closest('.menu-item-has-children > a');
            if (!target) return;
            
            e.preventDefault();
            const li = target.closest('li');
            
            if (li && li.classList.contains('is-opened')) {
                li.classList.remove('is-opened');
            } else if (li) {
                li.classList.add('is-opened');
            }
        });
    }

    static searchForm() {
        // Open search form overlay
        document.body.addEventListener('click', function (e) {
            const target = e.target.closest('.js-search-btn');
            if (!target) return;
            
            e.preventDefault();
            const overlay = document.querySelector('.js-search-form-overlay');
            if (overlay) overlay.classList.add('visible');
        });

        // Close search form overlay
        document.body.addEventListener('click', function (e) {
            const target = e.target.closest('.js-search-form-close');
            if (!target) return;
            
            e.preventDefault();
            const overlay = document.querySelector('.js-search-form-overlay');
            if (overlay) overlay.classList.remove('visible');
        });
    }
}